import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import MobileMenuPanel from './MobileMenuPanel';

interface MobileNavProps {
  user: any;
  onSignIn: () => void;
}

const MobileNav: React.FC<MobileNavProps> = ({ user, onSignIn }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      {/* Mobile Navigation Trigger */}
      <div className="lg:hidden flex items-center gap-2">
        {/* Sign In Button - Only when signed out, compact on mobile */}
        {!user && (
          <button
            onClick={onSignIn}
            className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium text-neutral-900 dark:text-white bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg hover:bg-neutral-50 dark:hover:bg-neutral-700 shadow-sm hover:shadow transition-all"
          >
            <img
              src="/google-icon.svg"
              alt="Google"
              width="14"
              height="14"
              loading="eager"
              decoding="async"
              className="w-3.5 h-3.5 flex-shrink-0"
            />
            <span className="whitespace-nowrap hidden xs:inline">Sign In</span>
          </button>
        )}

        {/* Hamburger Menu Button */}
        <button
          onClick={() => setIsMenuOpen(true)}
          className="p-1.5 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors"
          aria-label="Open menu"
          aria-expanded={isMenuOpen}
        >
          <Menu size={22} className="text-neutral-700 dark:text-neutral-300" />
        </button>
      </div>

      {/* Mobile Menu Panel */}
      <MobileMenuPanel isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
};

export default React.memo(MobileNav);
